<template>
  <div>
    <ul>
      <li v-for="element in vendors">
        {{ element }}
      </li>

    </ul>
  </div>
</template>
<script setup>

const locale = useLocale().getLocale();

const vendors = (await useApiFetch(`/api/nonSalableVendors?currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).groups
  .filter(v => v.groupTags.filter(t => t.idType == 1).length > 0).map(v => v.name).sort(function(a, b) {
    return a.localeCompare(b);
  });

</script>